export const ROUTES = {
  root: '/',
  dashboard: '/dashboard',
  signin: '/login',
  legacySignin: '/signIn',
  test: '/test',
  changePassword: '/market/register/changePassword',
  signup: '/signup',
  resetPassword: '/password-reset',
  updateAccount: '/update-account',

  market: '/market',
  marketRegister: '/market/register',
  marketCorrection: '/market/correction',
  reqAddMarket: '/market/add',
  MarketConnectionComplete: '/market/register/completed',
  myProfile: '/my/profile',
  inquiry: '/my/inquiry',
  inquiryHistory: '/my/inquiry/history',
  error: '/error',
  productShipment: '/productShipment',
  productShipmentGuide: '/productShipment/productShipmentGuide',
  functionGuide: '/market/functionGuide',
  admin: '/admin',
  labMain: '/labMain',
  makeName: '/makeName',
  changeName: '/changeName',
  diagnoseProduct: '/diagnoseProduct',
  membership: '/membership',
  mobileRoot: '/m',
  mobileMembership: '/m/membership',
  mobileSignin: '/m/login',
  mobileSignup: '/m/signup',
  mobileResetPassword: '/m/password-reset',
  mobileMembershipPayment: '/m/membership/payment',
  mobileMembershipActive: '/m/membership/active',
  mobileMembershipSubscribed: '/m/membership/subscribed',
  mobileMembershipAppSubscription: '/m/membership/app-subscription',
  mobileMembershipComplete: '/m/membership/complete',
  mobileKakaoPayApproval: '/m/kakaopayApproval',
  mobileKakaoPayCancel: '/m/kakaopayCancellation',
  mobileKakaoPayChangeApproval: '/m/kakaopayChangeApproval',
  mobileKakaoPayChangeCancel: '/m/kakaopayChangeCancellation',
  yearEnd: '/yearEnd',
  inquiryList: '/inquiryList',
  inquiryDetail: '/inquiryDetail',
  inquiryGuide: '/inquiryGuide',
  templatesInquiryList: '/templatesInquiryList',
  templatesInquiryDetail: '/templatesInquiryDetail',
  discoverMain: '/discoverMain',
  aiChatBot: '/aiChatBot',
  highAndLowStart: '/highAndLowStart',
  highAndLowCategoryList: '/highAndLowCategoryList',
  highAndLowGame: '/highAndLowGame',
  highAndLowResult: '/highAndLowResult',
  highAndLowRanking: '/highAndLowRanking',
  statisticsMain: '/statisticsMain',
  statistics: '/statistics',
  newsBriefing: '/news-briefing',
  orders: '/orders',
  orderDetails: '/orders/order-details',
  reviews: '/orders/reviews',
  inquiries: '/orders/inquiries',
  monitoring: '/monitoring',
  monitoringTutorial: '/monitoring/tutorial',
  productOptimization: '/product-optimization',
  pcRegister: 'pc/register',
  more: '/more',
  moreMembership: '/more/membership',
  PcMemberShip: 'more/membership',
  kakaoCallback: 'signin/kakao/callback',
  sellerBoxBlogMain: 'https://blog.sellerbox.io/',
  kakaoPayApproval: '/kakaopayApproval',
  kakaoPayCancel: '/kakaopayCancellation',
  kakaoPayChangeApproval: '/kakaopayChangeApproval',
  PcMarketConnectinoComplete: '/pc/market/register/completed',
  updateInfo: '/update-info',
  marketConnectMarketName: '/market/connect/:marketName',
  naverRegisterStart: '/naverRegisterStart',
  naverRegisterToken: '/naverRegisterToken',
  cafe24RegisterStart: '/cafe24RegisterStart',
  imwebRegisterStart: '/imwebRegisterStart',
  shopbyRegisterStart: '/shopbyRegisterStart',
  guide: '/guide',
  startStoreGuide: '/guide/startStore',
  intro: '/intro',
  surveys: '/surveys',
};
